import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { useGetSailInfoFeedback } from "../hooks/useGetSailInfoFeedback";
import { ISailDimension, ISailFeedback } from "../declarations";
import Rating from "@mui/material/Rating";
import Divider from "@mui/material/Divider";
import { DateTime } from "luxon";

type SailInfoFeedbackProps = {
    guid: string;
};

const SailInfoFeedback: React.FC<SailInfoFeedbackProps> = ({ guid }) => {
    const { data, isLoading } = useGetSailInfoFeedback(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Feedback" />
            <CardContent>
                <Grid container spacing={2}>
                    {data.map((feedback: ISailFeedback, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Rating
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Rating value={feedback.rating} readOnly />
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Description
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {feedback.dsc}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Date
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {DateTime.fromFormat(
                                            feedback.created,
                                            "MM/dd/yyyy hh:mm:ss",
                                        ).toLocaleString(DateTime.DATE_MED)}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Author
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {feedback.userName}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Approximate Sail Age
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {feedback.sailAge}
                                    </Typography>
                                </Grid>
                                {index < data.length - 1 && (
                                    <Divider sx={{ width: "100%" }} />
                                )}
                            </React.Fragment>
                        );
                    })}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoFeedback;
